module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hESHu"))).then(() => parcelRequire('dJXJK'));